import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0px 15px',
    width: '100%'
  },
  stickyDiv: {
    height: '100px',
    background: theme.palette.grey[800],

    position: 'sticky',
    alignItems: 'center',
    top: 0,
    left: 0,
    marginBottom: 10,
    zIndex: 5,
    [theme.breakpoints.down('sm')]: {
      margin: '0 -16px'
    }
  },
  noResultFound: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(5)
  },
  img: {
    width: '25%',
    [theme.breakpoints.down('sm')]: {
      width: '35%'
    }
  },
  noResults: {
    marginTop: 16,
    fontWeight: 500,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '5px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '5px 16px'
    }
  },
  backButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: 10
  },
  primaryTitle: {
    margin: '16px 0px',
    color: theme.palette.text.primary,
    fontSize: 18
  },

  availableRoomContainer: {
    display: 'grid',
    gridTemplateColumns: '2.9fr 1fr',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
    gap: 32,
    position: 'relative'
  },
  roomTypesContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 2.5,
    marginRight: 8
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'sticky',
    top: 96,
    height: 'fit-content'
  },
  filterText: { fontWeight: 600, color: theme.palette.grey[800] },

  btnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '14px',
    marginBottom: '15px',
    background: 'white',
    height: 100,
    zIndex: 1000,
    position: 'sticky',
    bottom: 0
  },
  bookingButton: {
    [theme.breakpoints.down('sm')]: {
      width: '45%'
    },
    width: '20%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cancelButton: {
    width: '20%',
    [theme.breakpoints.down('sm')]: {
      width: '45%'
    },
    height: 40
  },
  bookingButtonCancel: {
    width: '45%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  btnContinue: { width: '100%' },
  btnCancel: { width: '100%' },
  continueText: {
    color: theme.palette.primary.contrastText,
    fontSize: 16,
    fontWeight: 500
  },
  cancelText: {
    color: theme.palette.text.primary,
    fontSize: 16,
    fontWeight: 500
  },

  facilitiy: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}))
export default useStyles
